import { render, staticRenderFns } from "./detail_v2.vue?vue&type=template&id=4dc067f2&scoped=true&"
import script from "./detail_v2.vue?vue&type=script&lang=js&"
export * from "./detail_v2.vue?vue&type=script&lang=js&"
import style0 from "./detail_v2.vue?vue&type=style&index=0&id=4dc067f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc067f2",
  null
  
)

export default component.exports